import { isMockEnabled } from "@/lib/mock-flags";
import { fetchAllPaged } from "@/lib/api/paged";
import { mockNotifications } from "../mocks/fixtures";
import type { AppNotification, NotifKind } from "../stores/notificationsStore";

/** Item retornado por GET /v1/notifications (paginado). */
interface NotificationDto {
  id: string;
  kind: string;
  title: string;
  at: string;
  read: boolean;
  href?: string;
}

async function listReal(): Promise<AppNotification[]> {
  const rows = await fetchAllPaged<NotificationDto>("/notifications");
  return rows.map((n) => ({
    id: n.id,
    kind: n.kind as NotifKind,
    title: n.title,
    at: n.at,
    read: n.read,
    href: n.href,
  }));
}

/** Carga inicial da lista de notificações (o realtime chega depois via SSE). */
export function listNotifications(): Promise<AppNotification[]> {
  return isMockEnabled("notifications") ? Promise.resolve(mockNotifications) : listReal();
}
